<template>
  <div class="filter-products">
    <input-radioalt v-if="widgetType === 'radio'" :widgetStyle="widgetStyle" :fieldData="fieldData"></input-radioalt>
    <input-select-nt v-else :fieldData="fieldData"></input-select-nt>
  </div>
</template>

<script>

import InputSelectNt from '../InputSelectNt';
import InputRadioalt from '../InputRadioalt';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'widgetType', 'widgetStyle'],
  components: {
    InputSelectNt,
    InputRadioalt,
  },
  watch: {
    'fieldData.field_value': function fieldData(newValue) {
      sessionStorage.setItem(this.fieldData.field_name, newValue); // Store the date range to be referenced later
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/widgets/FilterProducts.vue?7cba4fef